import React, {
  useContext,
  useEffect,
  useState
}                                   from 'react';
import Request                      from '~/providers/Request';
import ItemEvent                    from './ItemEvent';
import RoutesContext                from './context/routesContext';
import EventRecord                  from '~/records/EventRecord';

function ShowPersonEvent({history}){
  const { id, event_id } = history.location.route.getParams();
  const {records, addRecords } = useContext(RoutesContext);
  const [geolocations, setGeolocations] = useState({});
  const [record, setRecord] = useState(new EventRecord());
  const [loading, setLoading] = useState(!records || !records[event_id]);

  useEffect(() => {
    setLoading(true);
    if(records && records[id]){
      setRecord( record.updateAttributes(records[id]) );
    }
    Request.get(`/admin/users/${id}/event/${event_id}`, {})
      .then(response => {
        setGeolocations(response.data.geolocations);
        setLoading(false);
        if(response.data.geolocations){
          response.data.geolocations = [];
        }
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  return (
    <ItemEvent
      record={record}
      loading={loading}
      geolocations={geolocations}
    />
  );
}

export default ShowPersonEvent;
